// Domain
import { ProofIncomeStatesEnumeration } from '../enumerations/proof-income-states.enumeration';

const DOMAIN =
  'lending.services.public.onboarding.lzOnboarding.proofOfIncome.proofOfIncomeFlowsConfiguration.';

const FETCHING_DESCRIPTION = `${DOMAIN}fetchingDescription`,
  FETCHING_TITLE = `${DOMAIN}fetchingTitle`,
  PROOF_INCOME_TITLES = {
    [ProofIncomeStatesEnumeration.LANDING]: `${DOMAIN}landingTitle`,
    [ProofIncomeStatesEnumeration.METHOD]: '',
  },
  PROOF_INCOME_DESCRIPTIONS = {
    [ProofIncomeStatesEnumeration.LANDING]: `${DOMAIN}landingDescription`,
    [ProofIncomeStatesEnumeration.METHOD]: '',
  };

export { FETCHING_DESCRIPTION, FETCHING_TITLE, PROOF_INCOME_TITLES, PROOF_INCOME_DESCRIPTIONS };
